import React from 'react';

import { CommonInputProps } from '../../types';
import { RCFormGroupAlertText } from '../../';

/** props that form elements typically pass through */
export interface CheckableLabelProps extends Omit<CommonInputProps, 'tag' | 'name'> {
  /** Additional line of text below main label; sentence-case without ending punctuation. Not rendered if `variant` is set to `switch`. */
  sublabel?: string;

  htmlFor?: string;
}

export function RCCheckableLabel({
  label,
  htmlFor = undefined,
  errorText = undefined,
  sublabel = undefined,
}: CheckableLabelProps) {
  return (
    <label
      className="rc-checkable-label"
      htmlFor={htmlFor}
    >
      {label}
      {sublabel && (
        <span className="rc-checkable-label__sublabel">
          {sublabel}
        </span>
      )}
      {errorText && (
        <RCFormGroupAlertText errorText={errorText} />
      )}
    </label>
  );
}
